import React from 'react'

// Fiche contact en LECTURE (pas un formulaire). Les champs à afficher sont ceux configurés côté BO
// (Domain.extended.USER_EXTENDEDS + EVENT_<id>_PARTICIPATION_EXTENDEDS), résolus côté serveur en
// { key, label, value } et renvoyés dans `user.fiche` par getUserByBadge. On affiche « label : valeur »
// (valeur vide → « — »), comme la fiche contact du BO.
export default function ContactDisplay({ fiche }) {
  if (!fiche || !fiche.length) return null

  const display = value => (value === '' || value === null || value === undefined ? '—' : value)

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, padding: 16 }}>
      {fiche.map((f, i) => (
        <div key={f.key || i} style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          <strong>{f.label} :</strong>
          <span>{display(f.value)}</span>
        </div>
      ))}
    </div>
  )
}
